import ConfirmModal from '@components/modal/ConfirmModal';
import usePublishChallenge from './_hooks/usePublishChallenge';
import { useEffect } from 'react';
import usePrevious from 'lib/src/hooks/usePrevious';

const PublishChallengeModal: React.FC<PublishChallengeModalProps> = ({
    challengeID,
    revert,
    setShowModal,
}) => {
    const { isPatching, patchError, patchSuccess, handleSubmit } = usePublishChallenge(
        challengeID,
        revert,
    );

    const prevPatchSuccess = usePrevious(patchSuccess);

    useEffect(() => {
        if (patchSuccess && !prevPatchSuccess) {
            setShowModal(false);
        }
    }, [patchSuccess, prevPatchSuccess, setShowModal]);

    const publishText = revert ? 'Unpublish' : 'Publish';

    return (
        <ConfirmModal
            title={`${publishText} challenge?`}
            description={`Are you sure you want to ${publishText} this challenge?`}
            closeModal={() => setShowModal(false)}
            handleSubmit={handleSubmit}
            isPosting={isPatching}
            error={patchError}
            submitText={publishText}
            submitColor={revert ? 'red' : 'green'}
        />
    );
};

interface PublishChallengeModalProps {
    challengeID: number;
    revert: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export default PublishChallengeModal;
